import { create_element } from 'js/utils';

export default class MB_Load_More {

    constructor(mb){
        this.mb = mb;
        this.have_more_items = false;
        this.show_items_num = this.mb.show_items_num || 12;
        
        this.create_elements();
        this.scroll_observer_init();

        this.mb.hooks.after_filter.push(this.update.bind(this));
        this.mb.hooks.after_search.push(this.update.bind(this));
        this.mb.hooks.after_add_items.push(this.update.bind(this));
    }

    update(){
        this.container.style.display = this.have_more_posts() ? '' : 'none';
    }

    load_more(){

        const items = this.mb.isotope.filteredItems;
        
        let count = 0;

        for( let i = 0; i < items.length; i++ ) {

            const item = items[i].element;

            if( item.classList.contains('mb_hidden') ) {
                item.classList.remove('mb_hidden');
                count++;
            }

            if( i === items.length-1 ) {
                this.have_more_items = false;
            }
            
            if( count === this.show_items_num ) break;
        }
        
        this.update();
        
        this.mb.isotope.layout();
    }

    create_elements(){
        this.container = create_element('mb_load_more_con', this.mb.container);
        this.container.style.display = 'none';

        this.button = create_element('mb_load_more_button button', this.container, 'Load More', 'button');
        this.button.addEventListener('click', this.load_more.bind(this));
    }

    scroll_observer_init(){

        if( !this.mb.settings.auto_load_more ) return;

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.button.click();
                }
            });
        });
        
        this.observer.observe(this.button);
    }
    
    have_more_posts(){
        const items = this.mb.isotope.filteredItems;
        for( let i = 0; i < items.length; i++ ) {
            let item = items[i].element;
            if( item.classList.contains('mb_hidden') ) {
                return true;
            }
        }
        return false;
    }
    
    create_elements(){
        this.container = create_element('mb_load_more_con', this.mb.container);
        this.container.style.display = 'none';

        this.button = create_element('mb_load_more_button button', this.container, 'Load More', 'button');
        this.button.addEventListener('click', this.load_more.bind(this));
    }
}